import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_billing_records_hub_ComponentContextService } from './FootprintManager.billing_records_hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { FootprintManager_billing_records_gridComponent } from './FootprintManager.billing_records_grid.component';
import { Invoices_billing_records_total_invoiced_by_date_widgetComponent } from './Invoices.billing_records_total_invoiced_by_date_widget.component';
import { Invoices_billing_record_total_billed_by_date_widgetComponent } from './Invoices.billing_record_total_billed_by_date_widget.component';
import { Invoices_billing_record_total_billed_by_current_month_widgetComponent } from './Invoices.billing_record_total_billed_by_current_month_widget.component';
import { Owners_owners_dd_singleComponent } from './Owners.owners_dd_single.component'
import { Owners_projects_dd_singleComponent } from './Owners.projects_dd_single.component'
import { Materials_materials_by_project_dd_multiComponent } from './Materials.materials_by_project_dd_multi.component'
import { Locations_warehouses_dd_multiComponent } from './Locations.warehouses_dd_multi.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_billing_records_gridComponent),
    forwardRef(() => Invoices_billing_records_total_invoiced_by_date_widgetComponent),
    forwardRef(() => Invoices_billing_record_total_billed_by_date_widgetComponent),
    forwardRef(() => Invoices_billing_record_total_billed_by_current_month_widgetComponent),
    forwardRef(() => Owners_owners_dd_singleComponent),
    forwardRef(() => Owners_projects_dd_singleComponent),
    forwardRef(() => Materials_materials_by_project_dd_multiComponent),
    forwardRef(() => Locations_warehouses_dd_multiComponent),
  ],
  selector: 'FootprintManager-billing_records_hub',
  templateUrl: './FootprintManager.billing_records_hub.component.html'
})
export class FootprintManager_billing_records_hubComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { currentDate?: string, current_date_corrected?: string } = { };
  //#endregion
  formGroup: FormGroup = new FormGroup({
    owner: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    materials: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    warehouse: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    include_cancelled: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    include_invoiced: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });
  
  toolbar = {
  };

  actionbar = {
  };

 filters = {
    owner: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['owner'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Owner', false, false),
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Project', false, false),
    materials: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['materials'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Material', false, false),
    warehouse: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['warehouse'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Warehouse', false, false),
    include_cancelled: new FieldModel(new CheckBoxModel(this.formGroup.controls['include_cancelled'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Include cancelled', false, false),
    include_invoiced: new FieldModel(new CheckBoxModel(this.formGroup.controls['include_invoiced'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Include invoiced', false, false),
  };


  filtersets = {
    newGroup1: new FieldsetModel(
      'Filters',
      false,
      true,
      false,
      false,
        null
      ,
      () => {
        const $hub = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      billing_records: new TabItemModel(
        this.rootTabGroup, 
        'Billing records', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    get $tabs_billing_records_billing_records_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $tabs_billing_records_billing_records_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_billing_records_billing_records_grid_inParams_materialIds: number[];
    get $tabs_billing_records_billing_records_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_billing_records_billing_records_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_billing_records_billing_records_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_billing_records_billing_records_grid_inParams_materialIds;
    }
  
    cacheValueFor_$tabs_billing_records_billing_records_grid_inParams_warehouseIds: number[];
    get $tabs_billing_records_billing_records_grid_inParams_warehouseIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.warehouse.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_billing_records_billing_records_grid_inParams_warehouseIds, expr)) {
        this.cacheValueFor_$tabs_billing_records_billing_records_grid_inParams_warehouseIds = expr;
      }
      return this.cacheValueFor_$tabs_billing_records_billing_records_grid_inParams_warehouseIds;
    }
  
    get $tabs_billing_records_billing_records_grid_inParams_includeCancelled(): boolean {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.include_cancelled.control.value;
      
      return expr;
    }
  
    get $tabs_billing_records_billing_records_grid_inParams_includeInvoiced(): boolean {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.include_invoiced.control.value;
      
      return expr;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_billing_records', { read: FootprintManager_billing_records_gridComponent }) $tabs_billing_records: FootprintManager_billing_records_gridComponent;
    //#endregion tabs children
    widgets = {
      billing_records_total_invoiced_by_date_widget: new WidgetModel(false),
      billing_records_total_billed_by_date_widget: new WidgetModel(false),
      billing_record_total_billed_by_current_month: new WidgetModel(false),
    };
  
    //#region widgets inParams
    get $widgets_billing_records_total_invoiced_by_date_widget_inParams_date(): string {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.vars.currentDate;
      
      return expr;
    }
  
    get $widgets_billing_records_total_invoiced_by_date_widget_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $widgets_billing_records_total_invoiced_by_date_widget_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$widgets_billing_records_total_invoiced_by_date_widget_inParams_warehouseIds: number[];
    get $widgets_billing_records_total_invoiced_by_date_widget_inParams_warehouseIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.warehouse.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_billing_records_total_invoiced_by_date_widget_inParams_warehouseIds, expr)) {
        this.cacheValueFor_$widgets_billing_records_total_invoiced_by_date_widget_inParams_warehouseIds = expr;
      }
      return this.cacheValueFor_$widgets_billing_records_total_invoiced_by_date_widget_inParams_warehouseIds;
    }
  
    cacheValueFor_$widgets_billing_records_total_invoiced_by_date_widget_inParams_materialIds: number[];
    get $widgets_billing_records_total_invoiced_by_date_widget_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_billing_records_total_invoiced_by_date_widget_inParams_materialIds, expr)) {
        this.cacheValueFor_$widgets_billing_records_total_invoiced_by_date_widget_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$widgets_billing_records_total_invoiced_by_date_widget_inParams_materialIds;
    }
  
    get $widgets_billing_records_total_billed_by_date_widget_inParams_date(): string {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.vars.currentDate;
      
      return expr;
    }
  
    get $widgets_billing_records_total_billed_by_date_widget_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $widgets_billing_records_total_billed_by_date_widget_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$widgets_billing_records_total_billed_by_date_widget_inParams_warehouseIds: number[];
    get $widgets_billing_records_total_billed_by_date_widget_inParams_warehouseIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.warehouse.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_billing_records_total_billed_by_date_widget_inParams_warehouseIds, expr)) {
        this.cacheValueFor_$widgets_billing_records_total_billed_by_date_widget_inParams_warehouseIds = expr;
      }
      return this.cacheValueFor_$widgets_billing_records_total_billed_by_date_widget_inParams_warehouseIds;
    }
  
    cacheValueFor_$widgets_billing_records_total_billed_by_date_widget_inParams_materialIds: number[];
    get $widgets_billing_records_total_billed_by_date_widget_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_billing_records_total_billed_by_date_widget_inParams_materialIds, expr)) {
        this.cacheValueFor_$widgets_billing_records_total_billed_by_date_widget_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$widgets_billing_records_total_billed_by_date_widget_inParams_materialIds;
    }
  
    get $widgets_billing_record_total_billed_by_current_month_inParams_date(): string {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.vars.currentDate;
      
      return expr;
    }
  
    get $widgets_billing_record_total_billed_by_current_month_inParams_owner_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $widgets_billing_record_total_billed_by_current_month_inParams_project_id(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$widgets_billing_record_total_billed_by_current_month_inParams_warehouse_ids: number[];
    get $widgets_billing_record_total_billed_by_current_month_inParams_warehouse_ids(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.warehouse.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_billing_record_total_billed_by_current_month_inParams_warehouse_ids, expr)) {
        this.cacheValueFor_$widgets_billing_record_total_billed_by_current_month_inParams_warehouse_ids = expr;
      }
      return this.cacheValueFor_$widgets_billing_record_total_billed_by_current_month_inParams_warehouse_ids;
    }
  
    cacheValueFor_$widgets_billing_record_total_billed_by_current_month_inParams_material_ids: number[];
    get $widgets_billing_record_total_billed_by_current_month_inParams_material_ids(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_billing_record_total_billed_by_current_month_inParams_material_ids, expr)) {
        this.cacheValueFor_$widgets_billing_record_total_billed_by_current_month_inParams_material_ids = expr;
      }
      return this.cacheValueFor_$widgets_billing_record_total_billed_by_current_month_inParams_material_ids;
    }
  
    //#endregion widgets inParams
  
    //#region widgets children
      @ViewChild('$widgets_billing_records_total_invoiced_by_date_widget', { read:  Invoices_billing_records_total_invoiced_by_date_widgetComponent }) $widgets_billing_records_total_invoiced_by_date_widget: Invoices_billing_records_total_invoiced_by_date_widgetComponent;
      @ViewChild('$widgets_billing_records_total_billed_by_date_widget', { read:  Invoices_billing_record_total_billed_by_date_widgetComponent }) $widgets_billing_records_total_billed_by_date_widget: Invoices_billing_record_total_billed_by_date_widgetComponent;
      @ViewChild('$widgets_billing_record_total_billed_by_current_month', { read:  Invoices_billing_record_total_billed_by_current_month_widgetComponent }) $widgets_billing_record_total_billed_by_current_month: Invoices_billing_record_total_billed_by_current_month_widgetComponent;
    //#endregion widgets children

  //#region filters inParams
  get $fields_owner_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_owner_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  get $fields_project_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_project_selector_inParams_ownerId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.owner.control.value;
    
    return expr;
  }



  get $fields_materials_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Billing records hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `View and invoice your billing activity`;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: FootprintManager_ShellService,
  private $datasources: FootprintManager_DatasourceService,
  private $flows: FootprintManager_FlowService,
  private $reports: FootprintManager_ReportService,
  private $localization: FootprintManager_LocalizationService,
  private $operations: FootprintManager_OperationService,
  private $logger: CleanupLoggerService,
  private $context: FootprintManager_billing_records_hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.billing_records,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Billing records hub';
    
    const $hub = this;
    const $utils = this.$utils;

    (this.filters.include_cancelled.control as CheckBoxModel).reset(false);
    (this.filters.include_invoiced.control as CheckBoxModel).reset(false);

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['owner']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_owner_change();
      });
    this.formGroup
      .controls['project']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_project_change();
      });
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region widgets children
    if (childToSkip !== '$widgets_billing_records_total_invoiced_by_date_widget') {
      if (!isNil(this.$widgets_billing_records_total_invoiced_by_date_widget) && !this.widgets.billing_records_total_invoiced_by_date_widget.hidden) {
        this.$widgets_billing_records_total_invoiced_by_date_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_billing_records_total_billed_by_date_widget') {
      if (!isNil(this.$widgets_billing_records_total_billed_by_date_widget) && !this.widgets.billing_records_total_billed_by_date_widget.hidden) {
        this.$widgets_billing_records_total_billed_by_date_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_billing_record_total_billed_by_current_month') {
      if (!isNil(this.$widgets_billing_record_total_billed_by_current_month) && !this.widgets.billing_record_total_billed_by_current_month.hidden) {
        this.$widgets_billing_record_total_billed_by_current_month.refresh(true, false, null);
      }
    }
    //#endregion widgets children
    //#region tabs children
    if (childToSkip !== '$tabs_billing_records') {
      if (!isNil(this.$tabs_billing_records) && !this.tabs.billing_records.hidden) {
        this.$tabs_billing_records.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootprintManager_billing_records_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_records_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_Navigation_Billing_Billing_Records.isAuthorized()) {
      
      $hub.close();
      throw new Error ('This screen currently requires authorization, please see your system admin for access.')
    
  }
  
  
  // Set the title
  $hub.title = 'Billing records hub'
  
  $hub.vars.currentDate = $utils.date.now();
  
  
  
  }
  on_owner_change(event = null) {
    return this.on_owner_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_owner_changeInternal(
    $hub: FootprintManager_billing_records_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_records_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $hub.filters.project.control.value = null;
  }
  on_project_change(event = null) {
    return this.on_project_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_changeInternal(
    $hub: FootprintManager_billing_records_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_records_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const projectId = $hub.filters.project.control.value
  
  
  // Set Owner from Project
  if ($utils.isDefined(projectId) && !$utils.isDefined($hub.filters.owner.control.value)) {
      const project = (await $datasources.Owners.ds_get_project_by_projectId.get({
          projectId: projectId
      })).result;
     
      if ($utils.isDefined(project)) {
  
          $hub.filters.owner.control.value = project[0].OwnerId;
  
      }
  
  }
  
  }
  //#endregion private flows
}
